import React, { useEffect, useState } from 'react';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import { SearchIcon } from 'icons';
import Modal from 'antd/lib/modal';
import Text from 'antd/lib/typography/Text';
import { fetchAnnotationsAsync, saveAnnotationsAsync } from '../../../../actions/annotation-actions';
import { getCVATStore } from '../../../../cvat-store';
import { Col, Row } from 'antd/lib/grid';
import Button from 'antd/lib/button';
import Select from 'antd/lib/select';
import Form from 'antd/lib/form';
import Notification from 'antd/lib/notification';
import withVisibilityHandling from './handle-popover-visibility';
import Popover from 'antd/lib/popover';
import Tooltip from 'antd/lib/tooltip';

export interface Props {
    jobId: number;
}

const CustomPopover = withVisibilityHandling(Popover, 'embedding-control');
function EmbeddingControl(props: Props): React.ReactNode {
    const { jobId } = props;
    const [models, setModels] = useState()
    const [saving, setSaving] = useState(false);
    const [active, setActive] = useState(false); // State to manage class change
    const [value, setValue] = useState([])
    const baseURL = window.location.origin;
    const storage = getCVATStore();

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`${baseURL}/api/get_library`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            } else {
                const data = await response.json()
                setModels(data)
            }

        }

        fetchData()
    }, [])

    const handleClick = async () => {
        setActive(true); // Set active to true on click
        await storage.dispatch(
            saveAnnotationsAsync(async () => {
                setSaving(true);
                try {
                    const response = await fetch(`${baseURL}/api/reference_jobs/${jobId}/models?library=${value?.map(String)}`, {
                        method: 'GET',
                    });
                    if (!response.ok) {
                        throw new Error(`Request failed with status ${response.status}`);
                    }
                    await storage.dispatch((fetchAnnotationsAsync(true)));
                } catch (error) {
                    console.error('Error:', error);
                    Notification.error({
                        message: "Error",
                        description: error.toString(),
                        className: 'cvat-notification-notice-get-issues-error',
                    });
                } finally {
                    setSaving(false);
                    setActive(false); // Set active to false after saving is done
                }
            }),
        );
    };

    const content = (
        <div className='cvat-opencv-control-popover-content'>
            <Row justify='start'>
                <Text className='cvat-text-color' strong>Select the directory for 3D models search</Text>
            </Row>
            <br />
            <Form.Item
                label={<Text>Select library</Text>}
                rules={[{ required: true, message: 'Directory must be selected' }]}
            >
                <Select
                    mode="multiple"
                    value={value?.map(String)}
                    placeholder="Select directory"
                    onChange={(_value: []) => {
                        setValue(_value);
                    }}
                    style={{ width: '350px' }}
                    className="cvat-task-search-field"
                >
                    {models && models.map(
                        (model) => (
                            <Select.Option value={model.value} title={model.value} key={model.key}>
                                <Tooltip title={model.key}>{model.key}</Tooltip>
                            </Select.Option>
                        ),
                    )}
                </Select>
            </Form.Item>
            <Row align="middle" justify="end">
                <Col>
                    <Button
                        className="cvat-inference-run-button"
                        type="primary"
                        onClick={handleClick}
                    >
                        Search
                    </Button>
                </Col>
            </Row>
        </div>
    )

    return (
        <CustomPopover
            overlayClassName='cvat-draw-shape-popover'
            placement='right'
            content={content}
        >
            <Icon
                className={`cvat-draw-rectangle-control ${active ? 'cvat-active-canvas-control' : 'cvat-disabled-canvas-control'} cvat-embedding-control`}
                component={SearchIcon}
                onMouseEnter={() => setActive(true)} // Set active to true on mouse enter
                onMouseLeave={() => setActive(false)} // Set active to false on mouse leave
            />
            <Modal
                className='cvat-saving-job-modal'
                title='Saving changes on the server'
                visible={saving}
                footer={null}
                closable={false}
            >
                <Text>Searching for matching 3D models based on your image. Please wait.</Text>
                <LoadingOutlined />
            </Modal>
        </CustomPopover>
    )
}

export default React.memo(EmbeddingControl);
